module.exports = __webpack_public_path__ + "media/images/favicon/primary/favicon-16x16-777c304d19f8bb068826ab1569690670.png";